import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CategorySource } from "@bitwarden/web-vault/app/models/types/category.types";

@Component({
  selector: "app-category-source-renderer",
  templateUrl: "./category-source-renderer.component.html",
})
export class CategorySourceRendererComponent implements ICellRendererAngularComp {
  source!: CategorySource;

  agInit(params: ICellRendererParams): void {
    this.setData(params);
  }

  setData(params: ICellRendererParams) {
    this.source = params.data.source;
  }

  refresh(params: ICellRendererParams): boolean {
    this.setData(params);
    return true;
  }
}
